import React from 'react';
import { TextField,MenuItem} from '@mui/material';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import { FormControl,   } from '@material-ui/core';


const SelectNormal = ({ label, options, value, onChange, required, size, readOnly }) => {
  return (
    <>
      {required && <label>{label} <span style={{ color: 'red' }}>*</span></label>}
      <TextField
        label={label}
        fullWidth
        select
        size={size}
        value={value}
        onChange={onChange}
        margin="normal"
        InputProps={readOnly ? { readOnly: true } : {}}
      >
        {options.map((option) => (
          <MenuItem key={option.Value} value={option.Value}>
            {option.Label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

const SelectNormalS = ({ label, options, value, onChange, required, size }) => {
  return (
    <>
     <FormControl fullWidth>
      {required && <label>{label} <span style={{ color: 'red' }}></span></label>}

      <TextField
        select
        label={label}

        fullWidth
        value={value}
        onChange={onChange}
        variant="outlined"
         margin="normal"

      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      </FormControl>
    </>
  );
}


const SelectSearch = ({ options, onChange, value, label, required, size  }) => {
  const selectedValue = value ? options.find(option => option.Value === value) : null;

  const handleChange = (event, selectedOption) => {
    onChange(selectedOption ? selectedOption.Value : null);
  };
  
  return (
    <>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.Label}
        size={size}
        value={selectedValue}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={required ? (
              <>
                {label} <span style={{ color: 'red' }}>*</span>
              </>
            ) : label}
            fullWidth
            margin="normal"
          />
        )}
      />
    </>
  );
};


const MultipleSelect = ({ options, onChange, value, label, required, size }) => {
  const selectedValues = Array.isArray(value) ? value : [];

  const handleChange = (event, selectedOptions) => {
    const selectedValues = selectedOptions.map(option => option.Value);
    onChange(selectedValues);
  };

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.Label}
      size={size}
      value={selectedValues}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={required ? (
            <>
              {label} <span style={{ color: 'red' }}>*</span>
            </>
          ) : label}
          fullWidth
          margin="normal"
        />
      )}
    />
  );
};

export { SelectNormal, SelectSearch, MultipleSelect, SelectNormalS };
